export const dataProcesosElectoralesPJ = [

  {
    id: 1,
    idModal: "PJ20242025_1",
    titulo: "Resultados de la Elección de Magistradas y Magistrados del Tribunal Superior de Justicia, en materia penal y especializada en administración de justicia para adolescentes",
    alt: "Magistrados Penal",
    documentos: [
      {
        id: 1,
        titleItem: "2025_SEE_MAG_LOC_TSJ_PEN_TLAX_CAS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_TSJ_PEN_TLAX_CAS.csv"
      },
      {
        id: 2,
        titleItem: "2025_SEE_MAG_LOC_TSJ_PEN_TLAX_DIS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_TSJ_PEN_TLAX_DIS.csv"
      },
      {
        id: 3,
        titleItem: "2025_SEE_MAG_LOC_TSJ_PEN_TLAX_DJ",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_TSJ_PEN_TLAX_DJ.csv"
      },
      {
        id: 4,
        titleItem: "2025_SEE_MAG_LOC_TSJ_PEN_TLAX_ENT",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_TSJ_PEN_TLAX_ENT.csv"
      },
      {
        id: 5,
        titleItem: "2025_SEE_MAG_LOC_TSJ_PEN_TLAX_MUN",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_TSJ_PEN_TLAX_MUN.csv"
      },
      {
        id: 6,
        titleItem: "2025_SEE_MAG_LOC_TSJ_PEN_TLAX_SEC",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_TSJ_PEN_TLAX_SEC.csv"
      },
      {
        id: 7,
        titleItem: "RESULTADOS_2025_MAG_LOC_TSJ_PEN_TLAX",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/RESULTADOS_2025_MAG_LOC_TSJ_PEN_TLAX.csv"
      }
    ]
  },
  
  {
    id: 2,
    idModal: "PJ20242025_2",
    titulo: "Resultados de la Elección de Magistradas y Magistrados del Tribunal Superior de Justicia, en materia civil y familiar",
    alt: "Magistrados Civil",
    documentos: [
      {
        id: 1,
        titleItem: "2025_SEE_MAG_LOC_TSJ_CIV_TLAX_CAS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_TSJ_CIV_TLAX_CAS.csv"
      },
      {
        id: 2,
        titleItem: "2025_SEE_MAG_LOC_TSJ_CIV_TLAX_DIS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_TSJ_CIV_TLAX_DIS.csv"
      },
      {
        id: 3,
        titleItem: "2025_SEE_MAG_LOC_TSJ_CIV_TLAX_DJ",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_TSJ_CIV_TLAX_DJ.csv"
      },
      {
        id: 4,
        titleItem: "2025_SEE_MAG_LOC_TSJ_CIV_TLAX_ENT",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_TSJ_CIV_TLAX_ENT.csv"
      },
      {
        id: 5,
        titleItem: "2025_SEE_MAG_LOC_TSJ_CIV_TLAX_MUN",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_TSJ_CIV_TLAX_MUN.csv"
      },
      {
        id: 6,
        titleItem: "2025_SEE_MAG_LOC_TSJ_CIV_TLAX_SEC",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_TSJ_CIV_TLAX_SEC.csv"
      },
      {
        id: 7,
        titleItem: "RESULTADOS_2025_MAG_LOC_TSJ_CIV_TLAX",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/RESULTADOS_2025_MAG_LOC_TSJ_CIV_TLAX.csv"
      }
    ]
  },
  
  {
    id: 3,
    idModal: "PJ20242025_3",
    titulo: "Resultados de la Elección de Magistradas y Magistrados del Tribunal de Disciplina Judicial",
    alt: "Tribunal Disciplina Judicial",
    documentos: [
      {
        id: 1,
        titleItem: "2025_SEE_MAG_LOC_DISC_TLAX_CAS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_DISC_TLAX_CAS.csv"
      },
      {
        id: 2,
        titleItem: "2025_SEE_MAG_LOC_DISC_TLAX_DIS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_DISC_TLAX_DIS.csv"
      },
      {
        id: 3,
        titleItem: "2025_SEE_MAG_LOC_DISC_TLAX_DJ",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_DISC_TLAX_DJ.csv"
      },
      {
        id: 4,
        titleItem: "2025_SEE_MAG_LOC_DISC_TLAX_ENT",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_DISC_TLAX_ENT.csv"
      },
      {
        id: 5,
        titleItem: "2025_SEE_MAG_LOC_DISC_TLAX_MUN",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_DISC_TLAX_MUN.csv"
      },
      {
        id: 6,
        titleItem: "2025_SEE_MAG_LOC_DISC_TLAX_SEC",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_DISC_TLAX_SEC.csv"
      },
      {
        id: 7,
        titleItem: "RESULTADOS_2025_MAG_LOC_DISC_TLAX",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/RESULTADOS_2025_MAG_LOC_DISC_TLAX.csv"
      }
    ]
  },
  
  {
    id: 4,
    idModal: "PJ20242025_4",
    titulo: "Resultados de la Elección de Magistradas y Magistrados del Tribunal de Justicia Administrativa",
    alt: "Tribunal Justicia Administrativa",
    documentos: [
      {
        id: 1,
        titleItem: "2025_SEE_MAG_LOC_JA_TLAX_CAS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_JA_TLAX_CAS.csv"
      },
      {
        id: 2,
        titleItem: "2025_SEE_MAG_LOC_JA_TLAX_DIS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_JA_TLAX_DIS.csv"
      },
      {
        id: 3,
        titleItem: "2025_SEE_MAG_LOC_JA_TLAX_DJ",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_JA_TLAX_DJ.csv"
      },
      {
        id: 4,
        titleItem: "2025_SEE_MAG_LOC_JA_TLAX_ENT",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_JA_TLAX_ENT.csv"
      },
      {
        id: 5,
        titleItem: "2025_SEE_MAG_LOC_JA_TLAX_MUN",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_JA_TLAX_MUN.csv"
      },
      {
        id: 6,
        titleItem: "2025_SEE_MAG_LOC_JA_TLAX_SEC",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_JA_TLAX_SEC.csv"
      },
      {
        id: 7,
        titleItem: "RESULTADOS_2025_MAG_LOC_JA_TLAX",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/RESULTADOS_2025_MAG_LOC_JA_TLAX.csv"
      }
    ]
  },
  
  {
    id: 5,
    idModal: "PJ20242025_5",
    titulo: "Resultados de la Elección de Magistradas y Magistrados del Tribunal de Conciliación y Arbitraje",
    alt: "Tribunal Conciliación y Arbitraje",
    documentos: [
      {
        id: 1,
        titleItem: "2025_SEE_MAG_LOC_CA_TLAX_CAS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_CA_TLAX_CAS.csv"
      },
      {
        id: 2,
        titleItem: "2025_SEE_MAG_LOC_CA_TLAX_DIS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_CA_TLAX_DIS.csv"
      },
      {
        id: 3,
        titleItem: "2025_SEE_MAG_LOC_CA_TLAX_DJ",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_CA_TLAX_DJ.csv"
      },
      {
        id: 4,
        titleItem: "2025_SEE_MAG_LOC_CA_TLAX_ENT",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_CA_TLAX_ENT.csv"
      },
      {
        id: 5,
        titleItem: "2025_SEE_MAG_LOC_CA_TLAX_MUN",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_CA_TLAX_MUN.csv"
      },
      {
        id: 6,
        titleItem: "2025_SEE_MAG_LOC_CA_TLAX_SEC",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_MAG_LOC_CA_TLAX_SEC.csv"
      },
      {
        id: 7,
        titleItem: "RESULTADOS_2025_MAG_LOC_CA_TLAX",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/RESULTADOS_2025_MAG_LOC_CA_TLAX.csv"
      }
    ]
  },
  
  {
    id: 6,
    idModal: "PJ20242025_6",
    titulo: "Resultados de la Elección de Juez o Jueza del Tribunal de enjuiciamiento Colegiado estatal",
    alt: "Tribunal Enjuiciamiento Colegiado",
    documentos: [
      {
        id: 1,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_TEC_TLAX_CAS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_TEC_TLAX_CAS.csv"
      },
      {
        id: 2,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_TEC_TLAX_DIS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_TEC_TLAX_DIS.csv"
      },
      {
        id: 3,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_TEC_TLAX_DJ",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_TEC_TLAX_DJ.csv"
      },
      {
        id: 4,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_TEC_TLAX_ENT",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_TEC_TLAX_ENT.csv"
      },
      {
        id: 5,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_TEC_TLAX_MUN",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_TEC_TLAX_MUN.csv"
      },
      {
        id: 6,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_TEC_TLAX_SEC",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_TEC_TLAX_SEC.csv"
      },
      {
        id: 7,
        titleItem: "RESULTADOS_2025_JUEZ_LOC_DIS_TEC_TLAX",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/RESULTADOS_2025_JUEZ_LOC_DIS_TEC_TLAX.csv"
      }
    ]
  },
  
  {
    id: 7,
    idModal: "PJ20242025_7",
    titulo: "Resultados de la Elección de Juez o Jueza del juzgado de ejecución especializado de medidas aplicables a adolescentes y de ejecución de sanciones penales del estado",
    alt: "Juzgado Ejecución Penal",
    documentos: [
      {
        id: 1,
        titleItem: "2025_SEE_JUEZ_LOC_JEEMAAES_TLAX_CAS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_JEEMAAES_TLAX_CAS.csv"
      },
      {
        id: 2,
        titleItem: "2025_SEE_JUEZ_LOC_JEEMAAES_TLAX_DIS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_JEEMAAES_TLAX_DIS.csv"
      },
      {
        id: 3,
        titleItem: "2025_SEE_JUEZ_LOC_JEEMAAES_TLAX_DJ",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_JEEMAAES_TLAX_DJ.csv"
      },
      {
        id: 4,
        titleItem: "2025_SEE_JUEZ_LOC_JEEMAAES_TLAX_ENT",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_JEEMAAES_TLAX_ENT.csv"
      },
      {
        id: 5,
        titleItem: "2025_SEE_JUEZ_LOC_JEEMAAES_TLAX_MUN",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_JEEMAAES_TLAX_MUN.csv"
      },
      {
        id: 6,
        titleItem: "2025_SEE_JUEZ_LOC_JEEMAAES_TLAX_SEC",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_JEEMAAES_TLAX_SEC.csv"
      },
      {
        id: 7,
        titleItem: "RESULTADOS_2025_JUEZ_LOC_JEEMAAES_TLAX",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/RESULTADOS_2025_JUEZ_LOC_JEEMAAES_TLAX.csv"
      }
    ]
  },
  
  {
    id: 8,
    idModal: "PJ20242025_8",
    titulo: "Resultados de la Elección de Juez o Jueza del sistema tradicional penal y especializado en administración de justicia para adolescentes del estado",
    alt: "Sistema Penal Tradicional",
    documentos: [
      {
        id: 1,
        titleItem: "2025_SEE_JUEZ_LOC_JSTPEAJA_TLAX_CAS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_JSTPEAJA_TLAX_CAS.csv"
      },
      {
        id: 2,
        titleItem: "2025_SEE_JUEZ_LOC_JSTPEAJA_TLAX_DIS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_JSTPEAJA_TLAX_DIS.csv"
      },
      {
        id: 3,
        titleItem: "2025_SEE_JUEZ_LOC_JSTPEAJA_TLAX_DJ",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_JSTPEAJA_TLAX_DJ.csv"
      },
      {
        id: 4,
        titleItem: "2025_SEE_JUEZ_LOC_JSTPEAJA_TLAX_ENT",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_JSTPEAJA_TLAX_ENT.csv"
      },
      {
        id: 5,
        titleItem: "2025_SEE_JUEZ_LOC_JSTPEAJA_TLAX_MUN",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_JSTPEAJA_TLAX_MUN.csv"
      },
      {
        id: 6,
        titleItem: "2025_SEE_JUEZ_LOC_JSTPEAJA_TLAX_SEC",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_JSTPEAJA_TLAX_SEC.csv"
      },
      {
        id: 7,
        titleItem: "RESULTADOS_2025_JUEZ_LOC_JSTPEAJA_TLAX",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/RESULTADOS_2025_JUEZ_LOC_JSTPEAJA_TLAX.csv"
      }
    ]
  },
  
  {
    id: 9,
    idModal: "PJ20242025_9",
    titulo: "Resultados de la Elección de Juez o Jueza del Juzgado Laboral",
    alt: "Juzgado Laboral",
    documentos: [
      {
        id: 1,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_JL_TLAX_CAS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_JL_TLAX_CAS.csv"
      },
      {
        id: 2,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_JL_TLAX_DIS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_JL_TLAX_DIS.csv"
      },
      {
        id: 3,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_JL_TLAX_DJ",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_JL_TLAX_DJ.csv"
      },
      {
        id: 4,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_JL_TLAX_ENT",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_JL_TLAX_ENT.csv"
      },
      {
        id: 5,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_JL_TLAX_MUN",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_JL_TLAX_MUN.csv"
      },
      {
        id: 6,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_JL_TLAX_SEC",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_JL_TLAX_SEC.csv"
      },
      {
        id: 7,
        titleItem: "RESULTADOS_2025_JUEZ_LOC_DIS_JL_TLAX",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/RESULTADOS_2025_JUEZ_LOC_DIS_JL_TLAX.csv"
      }
    ]
  },
  
  {
    id: 10,
    idModal: "PJ20242025_10",
    titulo: "Resultados de la Elección de Juez o Jueza del Juzgado de lo familiar especializado en asuntos urgentes para mujeres que viven en situación de violencia",
    alt: "Juzgado Familiar Violencia",
    documentos: [
      {
        id: 1,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_TLAX_ENT",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_TLAX_ENT.csv"
      },
      {
        id: 2,
        titleItem: "2025_SEE_JUEZ_LOC_JFEAUM_TLAX_CAS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_JFEAUM_TLAX_CAS.csv"
      },
      {
        id: 3,
        titleItem: "2025_SEE_JUEZ_LOC_JFEAUM_TLAX_DIS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_JFEAUM_TLAX_DIS.csv"
      },
      {
        id: 4,
        titleItem: "2025_SEE_JUEZ_LOC_JFEAUM_TLAX_DJ",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_JFEAUM_TLAX_DJ.csv"
      },
      {
        id: 5,
        titleItem: "2025_SEE_JUEZ_LOC_JFEAUM_TLAX_MUN",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_JFEAUM_TLAX_MUN.csv"
      },
      {
        id: 6,
        titleItem: "2025_SEE_JUEZ_LOC_JFEAUM_TLAX_SEC",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_JFEAUM_TLAX_SEC.csv"
      },
      {
        id: 7,
        titleItem: "RESULTADOS_2025_JUEZ_LOC_JFEAUM_TLAX",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/RESULTADOS_2025_JUEZ_LOC_JFEAUM_TLAX.csv"
      }
    ]
  },
  
  {
    id: 11,
    idModal: "PJ20242025_11",
    titulo: "Resultados de la Elección de Juez o Jueza en materia penal del distrito judicial Guridi y Alcocer",
    alt: "Distrito Guridi y Alcocer",
    documentos: [
      {
        id: 1,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_PGA_TLAX_CAS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_PGA_TLAX_CAS.csv"
      },
      {
        id: 2,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_PGA_TLAX_DIS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_PGA_TLAX_DIS.csv"
      },
      {
        id: 3,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_PGA_TLAX_DJ",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_PGA_TLAX_DJ.csv"
      },
      {
        id: 4,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_PGA_TLAX_ENT",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_PGA_TLAX_ENT.csv"
      },
      {
        id: 5,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_PGA_TLAX_MUN",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_PGA_TLAX_MUN.csv"
      },
      {
        id: 6,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_PGA_TLAX_SEC",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_PGA_TLAX_SEC.csv"
      },
      {
        id: 7,
        titleItem: "RESULTADOS_2025_JUEZ_LOC_DIS_PGA_TLAX",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/RESULTADOS_2025_JUEZ_LOC_DIS_PGA_TLAX.csv"
      }
    ]
  },
  
  {
    id: 12,
    idModal: "PJ20242025_12",
    titulo: "Resultados de la Elección de Juez o Jueza en materia penal del distrito judicial Sánchez Piedras",
    alt: "Distrito Sánchez Piedras",
    documentos: [
      {
        id: 1,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_PSP_TLAX_CAS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_PSP_TLAX_CAS.csv"
      },
      {
        id: 2,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_PSP_TLAX_DIS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_PSP_TLAX_DIS.csv"
      },
      {
        id: 3,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_PSP_TLAX_DJ",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_PSP_TLAX_DJ.csv"
      },
      {
        id: 4,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_PSP_TLAX_ENT",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_PSP_TLAX_ENT.csv"
      },
      {
        id: 5,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_PSP_TLAX_MUN",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_PSP_TLAX_MUN.csv"
      },
      {
        id: 6,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_PSP_TLAX_SEC",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_PSP_TLAX_SEC.csv"
      },
      {
        id: 7,
        titleItem: "RESULTADOS_2025_JUEZ_LOC_DIS_PSP_TLAX",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/RESULTADOS_2025_JUEZ_LOC_DIS_PSP_TLAX.csv"
      }
    ]
  },
  
  {
    id: 13,
    idModal: "PJ20242025_13",
    titulo: "Resultados de la Elección de Juez o Jueza en materia penal especializados en justicia para adolescentes del distrito judicial de Sánchez Piedras",
    alt: "Justicia Adolescentes Sánchez Piedras",
    documentos: [
      {
        id: 1,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_PSPE_TLAX_CAS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_PSPE_TLAX_CAS.csv"
      },
      {
        id: 2,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_PSPE_TLAX_DIS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_PSPE_TLAX_DIS.csv"
      },
      {
        id: 3,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_PSPE_TLAX_DJ",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_PSPE_TLAX_DJ.csv"
      },
      {
        id: 4,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_PSPE_TLAX_ENT",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_PSPE_TLAX_ENT.csv"
      },
      {
        id: 5,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_PSPE_TLAX_MUN",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_PSPE_TLAX_MUN.csv"
      },
      {
        id: 6,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_PSPE_TLAX_SEC",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/2025_SEE_JUEZ_LOC_DIS_PSPE_TLAX_SEC.csv"
      },
      {
        id: 7,
        titleItem: "RESULTADOS_2025_JUEZ_LOC_DIS_PSPE_TLAX",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/RESULTADOS_2025_JUEZ_LOC_DIS_PSPE_TLAX.csv"
      }
    ]
  },
  
  {
    id: 14,
    idModal: "PJ20242025_14",
    titulo: "Resultados de la Elección de Juez o Jueza en materia Civil",
    alt: "Materia Civil",
    documentos: [
      {
        id: 1,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_CIV_TLAX_CAS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025//14/2025_SEE_JUEZ_LOC_DIS_CIV_TLAX_CAS.csv"
      },
      {
        id: 2,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_CIV_TLAX_DIS",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025//14/2025_SEE_JUEZ_LOC_DIS_CIV_TLAX_DIS.csv"
      },
      {
        id: 3,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_CIV_TLAX_DJ",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025//14/2025_SEE_JUEZ_LOC_DIS_CIV_TLAX_DJ.csv"
      },
      {
        id: 4,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_CIV_TLAX_ENT",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025//14/2025_SEE_JUEZ_LOC_DIS_CIV_TLAX_ENT.csv"
      },
      {
        id: 5,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_CIV_TLAX_MUN",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025//14/2025_SEE_JUEZ_LOC_DIS_CIV_TLAX_MUN.csv"
      },
      {
        id: 6,
        titleItem: "2025_SEE_JUEZ_LOC_DIS_CIV_TLAX_SEC",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025//14/2025_SEE_JUEZ_LOC_DIS_CIV_TLAX_SEC.csv"
      },
      {
        id: 7,
        titleItem: "RESULTADOS_2025_JUEZ_LOC_DIS_CIV_TLAX",
        typeDocument: "excel",
        linkItem: "/assets/excel/procesosElect/PEPJ20242025/14/RESULTADOS_2025_JUEZ_LOC_DIS_CIV_TLAX.csv"
      }
    ]
  }
  
  ];